/** @jsxImportSource @emotion/react */
import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { useOrderPickingScan } from '../../OrderScanPicking'
import 'react-medium-image-zoom/dist/styles.css'
import { OrderItemRich } from '../OrderItemRich'
import { Divider, Icon } from 'semantic-ui-react'
import { isStatusAtLeast } from '../../../../../services/Order/order.helper'


const OrderItemsRich = ({
                            order,
                            hideable,
                        }) => {

    const {scannedItemsMap} = useOrderPickingScan()
    const [expandState, setExpandState] = useState(isStatusAtLeast(order?.status, 'READY') ? 'EXPAND' : 'COLLAPSE')

    return (
      <>
          {order.orderItems.some(orderItem => !!orderItem.pickingMethod) &&
            <div style={{textAlign: 'right', marginRight: '.7rem'}}>
                {expandState === 'COLLAPSE' && <Icon
                  color='grey'
                  onClick={() => {
                      setExpandState('EXPAND')
                  }}
                  name="folder"
                />}

                {expandState === 'EXPAND' && <Icon
                  color='grey'
                  onClick={() => {
                      setExpandState('COLLAPSE')
                  }}
                  name="folder open"
                />}
            </div>
          }
          {order.orderItems
            .filter(orderItem => !orderItem.fulfillmentIssueParentId)
            .map((orderItem) => (
              <Fragment key={orderItem.id}>
                  <OrderItemRich
                    order={order}
                    orderItem={orderItem}
                    hideable={hideable}
                    isChecked={orderItem.quantity === 0 ||
                      orderItem.fulfillmentIssue === 'OUT_OF_ITEM' ||
                      orderItem.fulfillmentIssue === 'PARTIAL_AVAILABILITY' ||
                      !!orderItem.pickingMethod}
                    expandState={expandState}
                    scanInfo={{
                        isScanned: scannedItemsMap.has(orderItem.id),
                        scannedQuantity: scannedItemsMap.get(orderItem.id),
                    }}
                    relatedReplacement={order.orderItems.find(oi => oi.fulfillmentIssueParentId === orderItem.id)}
                  />
                  <Divider/>
              </Fragment>
            ))}
      </>
    )
}

OrderItemsRich.propTypes = {
    orderItemsWithFulfillmentIssue: PropTypes.array,
    order: PropTypes.object.isRequired,
}

export default OrderItemsRich
